import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const About = () => {
  return (
    <div className="font-sans">
     
      <Navbar />

      {/* ZAJRAGREEN ABOUT PAGE CONTENT START */}
      <div className="min-h-screen bg-white text-slate-800">

        {/* HERO */}
        <header className="relative bg-gradient-to-r from-emerald-600 via-emerald-500 to-emerald-400 text-white">
          <div className="max-w-7xl mx-auto px-6 py-20 flex items-center gap-8">
            <div className="w-full lg:w-3/5">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight">
                END-TO-END TURF INSTALLATION FOR SPORTS GROUNDS
              </h1>
              <p className="mt-4 text-lg md:text-xl opacity-90">
                Our methodical approach ensures quality and longevity — from design to installation.
              </p>
            </div>

            <div className="hidden lg:block lg:w-2/5">
              <div
                className="rounded-xl overflow-hidden shadow-xl bg-cover bg-center h-56"
                style={{
                  backgroundImage: `url('https://images.pexels.com/photos/61135/pexels-photo-61135.jpeg')`,
                }}
              ></div>
            </div>
          </div>
        </header>

        <main className="max-w-7xl mx-auto px-6 py-16">

          {/* PROCESS STEPS */}
          <section className="mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-center">
              Our methodical approach ensures quality and longevity
            </h2>

            <div className="mt-10 space-y-12">

              {/* Step 01 */}
              <div className="bg-white border border-slate-100 rounded-xl shadow-sm p-6">
                <div className="text-sm text-slate-400 mb-2">Step 01</div>
                <h3 className="font-bold text-xl">Site Inspection & Leveling</h3>
                <p className="mt-3 text-slate-600">
                  We analyze the terrain, soil condition, water flow, and leveling requirements to prepare a perfectly stable base.
                </p>
              </div>

              {/* Step 02 */}
              <div className="bg-white border border-slate-100 rounded-xl shadow-sm p-6">
                <div className="text-sm text-slate-400 mb-2">Step 02</div>
                <h3 className="font-bold text-xl">Base Compaction & Drainage</h3>
                <p className="mt-3 text-slate-600">
                  A multi-layer drainage system with crushed stone and compacted aggregates ensures long-term durability.
                </p>
              </div>

              {/* Step 03 */}
              <div className="bg-white border border-slate-100 rounded-xl shadow-sm p-6">
                <div className="text-sm text-slate-400 mb-2">Step 03</div>
                <h3 className="font-bold text-xl">Turf Laying with Seam Joining</h3>
                <p className="mt-3 text-slate-600">
                  Premium turf rolls are installed with precision and invisible seam joining for a uniform playing surface.
                </p>
              </div>

              {/* Step 04 */}
              <div className="bg-white border border-slate-100 rounded-xl shadow-sm p-6">
                <div className="text-sm text-slate-400 mb-2">Step 04</div>
                <h3 className="font-bold text-xl">Infill & Final Grooming</h3>
                <p className="mt-3 text-slate-600">
                  We add silica sand and rubber granules to improve performance, cushioning, and safety — then groom it professionally.
                </p>
              </div>

            </div>
          </section>

          {/* APPLICATIONS SECTION */}
          <section>
            <h2 className="text-2xl md:text-3xl font-bold text-center">
              MULTI-SPORT TURF APPLICATIONS
            </h2>
            <p className="text-center text-slate-500 mt-2">
              We design turf systems tailored to each sport’s unique performance needs.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

              <div className="bg-white rounded-xl p-6 shadow border border-slate-100">
                <h3 className="text-lg font-semibold">Football Fields</h3>
                <p className="mt-2 text-slate-600">
                  FIFA-standard turf systems designed for perfect bounce, roll, and grip.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow border border-slate-100">
                <h3 className="text-lg font-semibold">Cricket Grounds</h3>
                <p className="mt-2 text-slate-600">
                  Low-friction surface with perfect shock absorption and consistent ball bounce.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow border border-slate-100">
                <h3 className="text-lg font-semibold">Hockey Fields</h3>
                <p className="mt-2 text-slate-600">
                  Fast-paced roll control meeting international competitive hockey standards.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow border border-slate-100">
                <h3 className="text-lg font-semibold">Athletics Grounds</h3>
                <p className="mt-2 text-slate-600">
                  Durable multi-use tracks ideal for training and running zones.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow border border-slate-100">
                <h3 className="text-lg font-semibold">School Playgrounds</h3>
                <p className="mt-2 text-slate-600">
                  Safe, high-traffic, budget-friendly turf for school activity areas.
                </p>
              </div>

            </div>

          </section>
        </main>
      </div>
      {/* ZAJRAGREEN ABOUT PAGE CONTENT END */}

      <Footer />
    </div>
  );
};

export default About;
